import {createReducer, on} from '@ngrx/store';
import {dialogDeleteConfigurationStateInitial} from './dialog-delete-configuration.state.initial';
import {DialogDeleteConfigurationActions} from './dialog-delete-configuration.actions';
import {DialogDeleteConfigurationState} from './dialog-delete-configuration.state';


export const dialogDeleteConfigurationReducers = createReducer(
  dialogDeleteConfigurationStateInitial,

  on(
    DialogDeleteConfigurationActions.open,
    (state): DialogDeleteConfigurationState => ({
      ...state,
      isOpen: true,
    }),
  ),

  on(
    DialogDeleteConfigurationActions.close,
    (state): DialogDeleteConfigurationState => ({
      ...state,
      isOpen: false,
    }),
  ),
);
